"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCalcWireAttachmentHeightFieldJoin = void 0;
var tslib_1 = require("tslib");
var field_join_ikecalc_1 = require("./field.join.ikecalc");
var WIRE_ATTACHMENT_HEIGHT = 'wireAttachmentHeight';
var IkeCalcWireAttachmentHeightFieldJoin = /** @class */ (function (_super) {
    tslib_1.__extends(IkeCalcWireAttachmentHeightFieldJoin, _super);
    function IkeCalcWireAttachmentHeightFieldJoin(field) {
        var _this = _super.call(this, field) || this;
        _this.type = 'IkeCalcWireAttachmentHeightJoin';
        return _this;
    }
    IkeCalcWireAttachmentHeightFieldJoin.accepts = function (field) {
        return field.schema.id === WIRE_ATTACHMENT_HEIGHT;
    };
    IkeCalcWireAttachmentHeightFieldJoin.prototype.joins = function (other) {
        var joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        var wireInsulator = this.getFieldValue(this.wire, 'wireInsulator');
        if (this.isDeadend(wireInsulator)) {
            return false;
        }
        if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
            return false;
        }
        return this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.circuit, other.circuit, 'circuitConstruction') &&
            this.fieldsEqual(this.wire, other.wire, 'wireInsulator') &&
            this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
            this.fieldsEqual(this.wire, other.wire, 'wireQuantity');
    };
    return IkeCalcWireAttachmentHeightFieldJoin;
}(field_join_ikecalc_1.IkeCalcFieldJoin));
exports.IkeCalcWireAttachmentHeightFieldJoin = IkeCalcWireAttachmentHeightFieldJoin;
//# sourceMappingURL=field.join.ikecalc.wire.js.map